import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { image_url } from '../../../config/Api'
import { getNews } from '../../actions/Publication';
import Timestamp from 'react-timestamp';

class ThirdSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      content: []
    }
  }


  componentDidMount = () => {
    const requestData = {
      take: 6,
      skip: 5,
    };
    const req = this.props.getNews(requestData).then((data) => {
      this.setState({
        content: data
      })
    });
  }

  // static getDerivedStateFromProps(props, state) {


  // }

  render() {

    const { content } = this.state;
    return (

      <section className="latest-news-last-six">

        <div className="container">

          <hr className="top-hr" />

          <div className="row">

            {content.length ? <Fragment>

              {content.map((row, key) => {
                return <Fragment key={key}>

                  <div className="col-md-4">

                    <div className="latest-news-last-six-single">

                      <div className="row">

                        <div className="col-md-6">

                          {row.image && <Fragment>
                            <img src={`${row.image.feature_image}`} />
                          </Fragment>}


                        </div>

                        <div className="col-md-6">

                        

                          <h3>
                        {row.title.length > 59 &&
                          <Link to={`/news/${row.categories[0]['id']}/${row.id}/details`}>{row.title.substring(0, 56)}...</Link>
                        }
                        {row.title.length <= 59 &&
                          <Link to={`/news/${row.categories[0]['id']}/${row.id}/details`}>{row.title}</Link>
                        }
                      </h3>

                          {row.published_time&&<p> <Timestamp relative date={row.published_time} autoUpdate /></p>}

                        </div>

                      </div>

                    </div>

                  </div>
                </Fragment>
              })}
            </Fragment> : ''}













          </div>

          <hr className="mid-hr" />

        </div>

      </section>
    );
  }
}


const mapStateToProps = (state) => ({
  headers: state.header,
  setting: state.utils.setting,
  home_layout: state.contents.home_layout,
})

const mapDispatchToProps = (dispatch) => ({
  getNews: (requestData) => dispatch(getNews(requestData)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ThirdSection);